import React, {useContext} from 'react'
import getAuditReducer from '../../state/audits/get-audit/reducer'
import getAuditsReducer from '../../state/audits/get-audits/reducer'
import getItemHistoryReducer from '../../state/audits/get-item-history/reducer'
import getassignToReducer from '../../state/audits/get-assigned-to/reducer'

import {getAudit, getNextPageItems} from '../../state/audits/get-audit/actions'
import {getSingleAudit} from '../../state/audits/get-single-audit'
import {getItemsHistory} from '../../state/audits/get-item-history/actions'
import {getAssignedTo} from '../../state/audits/get-assigned-to/actions'

import {
  getAudits,
  getNextPageAudits,
  getAuditItemsCount,
} from '../../state/audits/get-audits/actions'
import {updateAudit} from '../../state/audits/edit-audit/actions'
import {deleteAudit} from '../../state/audits/delete-audit/actions'
import {createAudit} from '../../state/audits/create-audit/actions'
import {closeIndividualAudit} from '../../state/audits/close-individual-audit/actions'
import {getAuditReport} from '../../state/AuditReports/get-audit-report/actions'
import {sendAuditReport} from '../../state/AuditReports/send-audit-report/actions'
import {transformDateFormat, transformTimeFormat} from '../../context/Reservation/util'
import {UserContext} from '../../context/User'
const AuditContext = React.createContext()

function AuditContextProvider(props) {
  const [itemStart, setItemStart] = React.useState(1)
  const [searchParams, setSearchParams] = React.useState({
    due_filter: '0',
    query: '',
    column_name: 'name',
    sort_by: 'ASC',
    limit: 25,
    type: 'audit',
    scanned_object_count: true,
  })
  const currentUser = useContext(UserContext)
  const date_format = transformDateFormat(currentUser?.details?.account_date_format)
  const time_format = transformTimeFormat(currentUser?.details?.account_time_format)

  const [audit, auditDispatch] = React.useReducer(getAuditReducer, '')
  const [audits, auditsDispatch] = React.useReducer(getAuditsReducer, '')
  const [itemHistory, itemHistoryDispatch] = React.useReducer(getItemHistoryReducer, '')
  const [assignTo, assignToDispatch] = React.useReducer(getassignToReducer, '')

  const getItemHistory = React.useCallback(data => getItemsHistory(data, itemHistoryDispatch), [])
  const getAssigTo = React.useCallback((params = {}) => getAssignedTo(params, assignToDispatch), [])

  const getReport = React.useCallback(params => getAuditReport(params), [])
  const sendReport = React.useCallback(params => sendAuditReport(params), [])

  const selectAudit = React.useCallback((data, reload = true, params = {}) => {
    getAudit(
      data,
      reload,
      {...params, start: 1, limit: 30, column_name: 'status', sort_by: 'ASC'},
      auditDispatch
    )
    setItemStart(1)
  }, [])

  const sortSelectAudit = React.useCallback(
    (data, reload = true, params = {}) => getAudit(data, reload, params, auditDispatch),
    []
  )

  const getsAudit = React.useCallback(id => getSingleAudit(id), [])
  const getAll = React.useCallback((params = {}) => getAudits(params, auditsDispatch), [])

  const getNextAudits = React.useCallback(
    (params = {}) => getNextPageAudits(params, auditsDispatch),
    []
  )

  const getItemsCount = React.useCallback(
    (params = {}) => getAuditItemsCount(params, auditsDispatch),
    []
  )

  const getNextItems = React.useCallback(
    (id, params = {}) => getNextPageItems(id, params, auditDispatch),
    []
  )

  const addAudit = React.useCallback(params => createAudit(params, searchParams, auditsDispatch), [
    searchParams,
  ])

  const editAudit = React.useCallback(
    (id, params = {}) => updateAudit(id, params, auditsDispatch),
    []
  )

  const remove = React.useCallback(id => deleteAudit(id, auditsDispatch), [])

  const closeAuditIndividual = React.useCallback(
    (id, params = {}) => closeIndividualAudit(id, params, auditsDispatch),
    []
  )

  const value = {
    audit,
    audits,
    searchParams,
    itemStart,
    itemHistory,
    assignTo,
    date_format,
    time_format,

    selectAudit,
    getAll,
    addAudit,
    editAudit,
    remove,
    closeAuditIndividual,
    getItemHistory,
    getAssigTo,
    getReport,
    getItemsCount,
    sendReport,
    getsAudit,
    setSearchParams,
    getNextAudits,
    setItemStart,
    getNextItems,
    sortSelectAudit,
  }

  return <AuditContext.Provider value={value}>{props.children}</AuditContext.Provider>
}

const AuditContextConsumer = AuditContext.Consumer

export {AuditContext, AuditContextProvider, AuditContextConsumer}
